<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-details details-area">
        <b-form novalidate class="">
          <div class="header-form">
            <h5 v-if="formType === 'edit'" class="form-header">
              Editar {{ equipment }} {{ oldAddr }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ pickedMod.NAME }}</h5>
          </div>
          <div class="pl-2 pr-2">
            <!-- NOME E ADDR -->
            <div class="col-xs-12">
              <b-form-text> Número do DIR (1 - 250)</b-form-text>
              <b-form-input
                :state="addrState"
                v-model="form.ADDR"
                type="number"
                min="1"
                max="250"
                size="sm"
                placeholder="Número"
              />
            </div>

            <!--ID, origem, stand by -->
            <!-- LATITUDE E LONGITUDE -->
            <div class="col-xs-12">
              <div class="group-inputs-title">Localização</div>
              <b-form-text v-show="form.LATITUDE">Latitude</b-form-text>
              <b-form-input
                :state="LATstate"
                v-model="form.LATITUDE"
                placeholder="Latitude"
                aria-describedby="latInputLiveFeedback"
                maxlength="40"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!LATstate"
                id="latInputLiveFeedback"
              >
                Permitidos apenas números, um único ponto decimal e um único
                hífen indicando valor negativo. Latitudes não podem ter valor
                menor que -90 ou maior que 90 graus.
              </b-form-invalid-feedback>
              <p />
              <b-form-text v-show="form.LONGITUDE">Longitude</b-form-text>
              <b-form-input
                :state="LONstate"
                v-model="form.LONGITUDE"
                placeholder="Longitude"
                aria-describedby="lonInputLiveFeedback"
                size="sm"
                maxlength="40"
              />
              <b-form-invalid-feedback
                v-if="!LONstate"
                id="lonInputLiveFeedback"
              >
                Permitidos apenas números, um único ponto decimal e um único
                hífen indicando valor negativo. Longitudes não podem ter valor
                menor que -180 ou maior que 180 graus.
              </b-form-invalid-feedback>
            </div>
            <div class="div col-xs-12">
              <div class="group-inputs-title">Equipamentos</div>
              <b-btn
                @click="show.emr = !show.emr"
                v-if="
                  (formType == 'add' &&
                    pickedMod.NAME &&
                    pickedMod.NAME.indexOf('EMR') > -1) ||
                  (formType == 'edit' &&
                    form.MODEL_NAME &&
                    form.MODEL_NAME.indexOf('EMR') > -1)
                "
                block
                size="sm"
                rounded
                variant="orange"
                >Sensor de estação ({{ form.EMR ? 1 : 0 }}/1)
              </b-btn>
              <searchable-select
                v-if="show.emr"
                v-model="form.EMR"
                class="col-xs-11"
                :options="emrsensors"
                text-field="NAME"
                value-field="ID"
                placeholder="Sensor de EMR"
                :current-value="formType == 'edit' ? form.EMR : null"
                :current-label="form.EQUIP_ON_EMR"
              />

              <b-btn
                @click="show.pir = !show.pir"
                v-if="
                  (formType == 'add' &&
                    pickedMod.NAME &&
                    pickedMod.NAME.indexOf('PIR') > -1) ||
                  (formType == 'edit' &&
                    form.MODEL_NAME &&
                    form.MODEL_NAME.indexOf('PIR') > -1)
                "
                block
                size="sm"
                rounded
                variant="orange"
                >Sensor PIR ({{ form.PIR ? 1 : 0 }}/1)
              </b-btn>
              <searchable-select
                v-if="show.pir"
                v-model="form.PIR"
                class="col-xs-11"
                :options="pirsensors"
                text-field="NAME"
                value-field="ID"
                placeholder="Sensor PIR"
                :current-value="formType == 'edit' ? form.PIR : null"
                :current-label="form.EQUIP_ON_PIR"
              />

              <b-btn
                @click="show.valve = !show.valve"
                v-if="modelSpecification.valve.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Atuadores ({{
                  modelSpecification.valve.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.valve.length }})</b-btn
              >
              <div v-if="show.valve">
                <div
                  v-for="valve in modelSpecification.valve"
                  :key="valve.POSITION"
                  class="row around-xs middle-xs"
                >
                  <b-form-text class="col-xs-12">
                    Saída {{ valve.POSITION }}
                  </b-form-text>
                  <searchable-select
                    class="col-xs-5"
                    v-model="valve.EQUIPMENT"
                    placeholder="Equipamento"
                    :current-value="formType == 'edit' ? valve.CURRENT_EQUIPMENT : null"
                    :current-label="valve.NAME_EQUIPMENT"
                    :groups="[
                      { label: 'Válvulas', items: valves, textField: 'NAME', valueField: 'ID' },
                      { label: 'Bombas', items: pumps, textField: 'NAME', valueField: 'ID' },
                    ]"
                  />
                  <b-form-select
                    size="sm"
                    class="col-xs-5"
                    v-model="valve.OPERATION"
                  >
                    <option :value="2">Abrir e Fechar</option>
                    <option :value="1">Abrir</option>
                    <option :value="0">Fechar</option>
                  </b-form-select>
                </div>
              </div>
              <b-btn
                @click="show.p_modbus = !show.p_modbus"
                v-if="modelSpecification.p_modbus.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Bombas modbus ({{
                  modelSpecification.p_modbus.filter((e) => !!e.EQUIPMENT)
                    .length
                }}/{{ modelSpecification.p_modbus.length }})</b-btn
              >
              <div v-if="show.p_modbus">
                <div
                  v-for="pm in modelSpecification.p_modbus"
                  :key="pm.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="pm.EQUIPMENT"
                    class="col-xs-11"
                    :options="modbusPumps"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`Equipamento ${pm.POSITION}`"
                    :current-value="formType == 'edit' ? pm.CURRENT_EQUIPMENT : null"
                    :current-label="pm.NAME_EQUIPMENT"
                  />
                </div>
              </div>
              <b-btn
                @click="show.digital = !show.digital"
                v-if="modelSpecification.digital.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Hidrômetros/Sensores de pulso ({{
                  modelSpecification.digital.filter((e) => !!e.EQUIPMENT)
                    .length
                }}/{{ modelSpecification.digital.length }})</b-btn
              >
              <div v-if="show.digital">
                <div
                  v-for="digital in modelSpecification.digital"
                  :key="digital.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="digital.EQUIPMENT"
                    class="col-xs-11"
                    :placeholder="`Hidrômetro/Sensor de Pulso ${digital.POSITION}`"
                    :current-value="formType == 'edit' ? digital.CURRENT_EQUIPMENT : null"
                    :current-label="digital.NAME_EQUIPMENT"
                    :groups="[
                      { label: 'Hidrômetros', items: hydros, textField: 'NAME', valueField: 'ID', prefix: 'h' },
                      { label: 'Sensores de pulso', items: pulses, textField: 'NAME', valueField: 'ID', prefix: 'p' },
                    ]"
                  />
                </div>
              </div>
              <b-btn
                @click="show.sensor = !show.sensor"
                v-if="modelSpecification.sensor.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores analógicos ({{
                  modelSpecification.sensor.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.sensor.length }})</b-btn
              >
              <div v-if="show.sensor">
                <div
                  v-for="sensor in modelSpecification.sensor"
                  :key="sensor.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="sensor.EQUIPMENT"
                    class="col-xs-11"
                    :options="sensors"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`Analógico ${sensor.POSITION}`"
                    :current-value="formType == 'edit' ? sensor.CURRENT_EQUIPMENT : null"
                    :current-label="sensor.NAME_EQUIPMENT"
                  />
                </div>
              </div>
              <b-btn
                @click="show.onoff = !show.onoff"
                v-if="modelSpecification.onoff.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores ON/OFF ({{
                  modelSpecification.onoff.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.onoff.length }})</b-btn
              >
              <div v-if="show.onoff">
                <div
                  v-for="onoff in modelSpecification.onoff"
                  :key="onoff.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="onoff.EQUIPMENT"
                    class="col-xs-11"
                    :options="onoffs"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`Sensores On/Off ${onoff.POSITION}`"
                    :current-value="formType == 'edit' ? onoff.CURRENT_EQUIPMENT : null"
                    :current-label="onoff.NAME_EQUIPMENT"
                  />
                </div>
              </div>
              <b-btn
                @click="show.s_modbus = !show.s_modbus"
                v-if="modelSpecification.s_modbus.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores modbus ({{
                  modelSpecification.s_modbus.filter((e) => !!e.EQUIPMENT)
                    .length
                }}/{{ modelSpecification.s_modbus.length }})
              </b-btn>
              <div v-if="show.s_modbus">
                <div
                  v-for="sm in modelSpecification.s_modbus"
                  :key="sm.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="sm.EQUIPMENT"
                    class="col-xs-11"
                    :options="modbusSensors"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`Equipamento ${sm.POSITION}`"
                    :current-value="formType == 'edit' ? sm.CURRENT_EQUIPMENT : null"
                    :current-label="sm.NAME_EQUIPMENT"
                  />
                </div>
              </div>

              <b-btn
                @click="show.i2c = !show.i2c"
                v-if="modelSpecification.i2c.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores I2C ({{
                  modelSpecification.i2c.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.i2c.length }})</b-btn
              >
              <div v-if="show.i2c">
                <div
                  v-for="i2c in modelSpecification.i2c"
                  :key="i2c.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="i2c.EQUIPMENT"
                    class="col-xs-11"
                    :options="sensorsi2c"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`I2C ${i2c.POSITION}`"
                    :current-value="formType == 'edit' ? i2c.CURRENT_EQUIPMENT : null"
                    :current-label="i2c.NAME_EQUIPMENT"
                  />
                </div>
              </div>

              <b-btn
                @click="show.sdi12 = !show.sdi12"
                v-if="modelSpecification.sdi12.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores SDI-12 ({{
                  modelSpecification.sdi12.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.sdi12.length }})
              </b-btn>
              <div v-if="show.sdi12">
                <div
                  v-for="sdi12 in modelSpecification.sdi12"
                  :key="sdi12.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="sdi12.EQUIPMENT"
                    class="col-xs-11"
                    :options="sensorssdi"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`SDI-12 ${sdi12.POSITION}`"
                    :current-value="
                      formType == 'edit' || (formType == 'duplicate' && sdi12.CURRENT_EQUIPMENT)
                        ? sdi12.CURRENT_EQUIPMENT
                        : null
                    "
                    :current-label="sdi12.NAME_EQUIPMENT"
                  />
                </div>
              </div>
            </div>

            <!-- OBSERVAÇÕES -->
            <div class="col-xs-12">
              <div class="group-inputs-title">Extra:</div>
              <b-form-text>Observações</b-form-text>
              <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
              <b-form-input
                v-model="form.NOTE"
                placeholder="Observações"

                maxlength="40"
                size="sm"
                rounded
              >
              </b-form-input>
            </div>
          </div>
        </b-form>
      </div>
      <footer id="footer">
        <b-btn
          size="sm"
          variant="outline-secondary"
          @click="$emit('close-form')"
          class="mr-1 ml-2"
        >
          Fechar
        </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2">
          Salvar
        </b-btn>
      </footer>
    </div>
    <b-modal
      ref="formError"
      no-close-on-backdrop
      centered
      hide-footer
      body-bg-variant="light"
      title="Atenção!"
    >
      <div class="modal-form row pb-3">
        <div class="col-xs-12 center-xs">
          <alert-icon title="" style="font-size: 3em; color: #ffc107" />
        </div>
        <div class="col-xs-12 error-title">
          Não é possível salvar os dados do formulário porque:
        </div>
        <div class="col-xs-12 error-description">
          <ul>
            <li v-for="err in errors" :key="err">{{ err }}</li>
          </ul>
        </div>
      </div>
      <b-btn
        v-if="$refs.formError"
        block
        variant="secondary"
        size="sm"
        @click="$refs.formError.hide"
        >Irei corrigir</b-btn
      >
    </b-modal>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "dir-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    formType: String,
    equipment: String,
    models: Array,
    pickedMod: Object,
    alreadyUsedAddrs: [Number, Array],
    oldAddr: [Boolean, Number],
    itemToEdit: [Boolean, Number, Object],
    emrsensors: Array,
    pirsensors: Array,
    valves: Array,
    pumps: Array,
    modbusPumps: Array,
    hydros: Array,
    pulses: Array,
    sensors: Array,
    onoffs: Array,
    modbusSensors: Array,
    sensorsi2c: Array,
    sensorssdi: Array,
  },
  data() {
    return {
      errors: [],
      step: 1,
      form: {
        ADDR: null,
        MODEL_NAME: null,
        LATITUDE: null,
        LONGITUDE: null,
        O1: null,
        O1F: null,
        O2: null,
        O2F: null,
        O3: null,
        O3F: null,
        O4: null,
        O4F: null,
        O5: null,
        O5F: null,
        O6: null,
        O6F: null,
        O7: null,
        O7F: null,
        O8: null,
        O8F: null,
        O9: null,
        O9F: null,
        O10: null,
        O10F: null,
        O11: null,
        O11F: null,
        O12: null,
        O12F: null,
        O13: null,
        O13F: null,
        O14: null,
        O14F: null,
        O15: null,
        O15F: null,
        O16: null,
        O16F: null,
        O17: null,
        O17F: null,
        O18: null,
        O18F: null,
        O19: null,
        O19F: null,
        O20: null,
        O20F: null,
        O21: null,
        O21F: null,
        O22: null,
        O22F: null,
        O23: null,
        O23F: null,
        O24: null,
        O24F: null,
        O25: null,
        O25F: null,
        O26: null,
        O26F: null,
        O27: null,
        O27F: null,
        O28: null,
        O28F: null,
        O29: null,
        O29F: null,
        O30: null,
        O30F: null,
        O31: null,
        O31F: null,
        O32: null,
        O32F: null,
        M1: null,
        M2: null,
        M3: null,
        M4: null,
        M5: null,
        M6: null,
        M7: null,
        M8: null,
        SM1: null,
        SM2: null,
        SM3: null,
        SM4: null,
        SM5: null,
        SM6: null,
        SM7: null,
        SM8: null,
        D1: null,
        D2: null,
        D3: null,
        D4: null,
        D5: null,
        D6: null,
        D7: null,
        D8: null,
        P1: null,
        P2: null,
        P3: null,
        P4: null,
        P5: null,
        P6: null,
        P7: null,
        P8: null,
        L1: null,
        L2: null,
        L3: null,
        L4: null,
        L5: null,
        L6: null,
        L7: null,
        L8: null,
        A1: null,
        A2: null,
        A3: null,
        A4: null,
        A5: null,
        A6: null,
        A7: null,
        A8: null,
        I2C: null,
        I2C1: null,
        I2C2: null,
        I2C3: null,
        I2C4: null,
        I2C5: null,
        I2C6: null,
        I2C7: null,
        SDI12: null, // Remover
        SDI12I1: null,
        SDI12I2: null,
        SDI12I3: null,
        SDI12I4: null,
        SDI12I5: null,
        SDI12I6: null,
        SDI12I7: null, // Remover
        EMR: null,
        PIR: null,
        FK_MODEL: null,
        NOTE: null,
      },
      pickedModel: {},
      modelSpecification: {
        s_modbus: [],
        p_modbus: [],
        valve: [],
        hydro: [],
        digital: [],
        sensor: [],
        onoff: [],
        pulse: [],
        i2c: [],
        sdi12: [],
      },
      show: {
        emr: false,
        pir: false,
        s_modbus: false,
        p_modbus: false,
        valve: false,
        hydro: false,
        digital: false,
        sensor: false,
        onoff: false,
        pulse: false,
        i2c: false,
        sdi12: false,
      },
      repetitions: [],
      isFir: false,
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.show = {
          emr: false,
          s_modbus: false,
          p_modbus: false,
          valve: false,
          hydro: false,
          digital: false,
          sensor: false,
          onoff: false,
          pulse: false,
          i2c: false,
          sdi12: false,
        };
        if (this.formType == "add") this.resetForm();
        // Edit
        else {
          this.form.ID = this.itemToEdit.ID;
          this.form.ADDR = this.itemToEdit.ADDR;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.MODEL_NAME = this.itemToEdit.MODEL_NAME;
          this.form.EMR = this.itemToEdit.EMR;
          this.form.EQUIP_ON_EMR = this.itemToEdit.EQUIP_ON_EMR;
          this.form.PIR = this.itemToEdit.PIR;
          this.form.EQUIP_ON_PIR = this.itemToEdit.EQUIP_ON_PIR;
          this.modelSpecification = {
            s_modbus: this.itemToEdit.S_MODBUS,
            p_modbus: this.itemToEdit.P_MODBUS,
            valve: this.itemToEdit.VALVE,
            hydro: this.itemToEdit.HYDRO,
            digital: this.joinDigitalInput(),
            sensor: this.itemToEdit.SENSOR,
            onoff: this.itemToEdit.ONOFF,
            pulse: this.itemToEdit.PULSE,
            i2c: this.itemToEdit.I2C,
            sdi12: this.itemToEdit.SDI12,
          };
          this.form.NOTE = this.itemToEdit.NOTE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.MODEL_NAME);
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    addrState() {
      let addr = Number(this.form.ADDR);
      let valid = !!addr && addr <= 250;
      let exist = this.alreadyUsedAddrs && this.alreadyUsedAddrs.includes(addr);
      if (this.formType == "edit") {
        let currently = addr == this.oldAddr;
        return valid && (currently || !exist);
      } else {
        return valid && !exist;
      }
    },
  },
  created() {
    if (this.formType === "add") {
      console.log('CREATED -> ADD -> pickedMod ',this.pickedMod);
      this.makeModelSpecificationObj("s_modbus", 8, "mb");
      this.makeModelSpecificationObj("p_modbus", 8, "mb");
      this.makeModelSpecificationObj("onoff", 8, "onoff");
      this.makeModelSpecificationObj("valve", this.pickedMod.OUT, "out");
      this.makeModelSpecificationObj(
        "digital",
        this.pickedMod.IN_DIGITAL,
        "dig"
      );
      this.makeModelSpecificationObj(
        "sensor",
        this.pickedMod.IN_ANALOGIC,
        "an"
      );
      this.makeModelSpecificationObj("i2c", this.pickedMod.IN_I2C, "i2c");
      this.makeModelSpecificationObj("sdi12", this.pickedMod.IN_SDI12, "sdi12");
    }  else {

      this.form.ID = this.itemToEdit.ID;
      this.form.ADDR = this.itemToEdit.ADDR;
      this.form.LATITUDE = this.itemToEdit.LATITUDE;
      this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
      this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
      this.form.MODEL_NAME = this.itemToEdit.MODEL_NAME;
      this.form.EMR = this.itemToEdit.EMR;
      this.form.EQUIP_ON_EMR = this.itemToEdit.EQUIP_ON_EMR;
      this.form.PIR = this.itemToEdit.PIR;
      this.form.EQUIP_ON_PIR = this.itemToEdit.EQUIP_ON_PIR;
      this.modelSpecification = {
        s_modbus: this.itemToEdit.S_MODBUS,
        p_modbus: this.itemToEdit.P_MODBUS,
        valve: this.itemToEdit.VALVE,
        hydro: this.itemToEdit.HYDRO,
        digital: this.joinDigitalInput(),
        sensor: this.itemToEdit.SENSOR,
        onoff: this.itemToEdit.ONOFF,
        pulse: this.itemToEdit.PULSE,
        i2c: this.itemToEdit.I2C,
        sdi12: this.itemToEdit.SDI12,
      };
      this.form.NOTE = this.itemToEdit.NOTE;
    }
  },
  methods: {
    labelsFir(i) {
      let labels = [
        "Válvula de Água",
        "Válvula Canal 01",
        "Válvula Canal 02",
        "Válvula Canal 03",
        "Válvula Canal 04",
        "Válvula Canal 05",
        "Válvula Canal 06",
        "Válvula Canal 07",
        "Válvula Canal 08",
        "Válvula Canal 09",
        "Válvula Canal 10",
        "Válvula Canal 11",
        "Válvula Canal 12",
        "Válvula Canal 13",
        "Válvula Canal 14",
        "Válvula Canal 15",
        "Adutora 01",
        "Adutora 02",
      ];
      return labels[i];
    },
    resetForm() {
      this.form = {
        ADDR: null,
        NAME: null,
        LATITUDE: null,
        LONGITUDE: null,
        MODEL_NAME: null,
        O1: null,
        O1F: null,
        O2: null,
        O2F: null,
        O3: null,
        O3F: null,
        O4: null,
        O4F: null,
        O5: null,
        O5F: null,
        O6: null,
        O6F: null,
        O7: null,
        O7F: null,
        O8: null,
        O8F: null,
        O9: null,
        O9F: null,
        O10: null,
        O10F: null,
        O11: null,
        O11F: null,
        O12: null,
        O12F: null,
        O13: null,
        O13F: null,
        O14: null,
        O14F: null,
        O15: null,
        O15F: null,
        O16: null,
        O16F: null,
        O17: null,
        O17F: null,
        O18: null,
        O18F: null,
        O19: null,
        O19F: null,
        O20: null,
        O20F: null,
        O21: null,
        O21F: null,
        O22: null,
        O22F: null,
        O23: null,
        O23F: null,
        O24: null,
        O24F: null,
        O25: null,
        O25F: null,
        O26: null,
        O26F: null,
        O27: null,
        O27F: null,
        O28: null,
        O28F: null,
        O29: null,
        O29F: null,
        O30: null,
        O30F: null,
        O31: null,
        O31F: null,
        O32: null,
        O32F: null,
        M1: null,
        M2: null,
        M3: null,
        M4: null,
        M5: null,
        M6: null,
        M7: null,
        M8: null,
        SM1: null,
        SM2: null,
        SM3: null,
        SM4: null,
        SM5: null,
        SM6: null,
        SM7: null,
        SM8: null,
        D1: null,
        D2: null,
        D3: null,
        D4: null,
        D5: null,
        D6: null,
        D7: null,
        D8: null,
        P1: null,
        P2: null,
        P3: null,
        P4: null,
        P5: null,
        P6: null,
        P7: null,
        P8: null,
        L1: null,
        L2: null,
        L3: null,
        L4: null,
        L5: null,
        L6: null,
        L7: null,
        L8: null,
        A1: null,
        A2: null,
        A3: null,
        A4: null,
        A5: null,
        A6: null,
        A7: null,
        A8: null,
        I2C: null,
        I2C1: null,
        I2C2: null,
        I2C3: null,
        I2C4: null,
        I2C5: null,
        I2C6: null,
        I2C7: null,
        SDI12: null, //Remover
        SDI12I1: null,
        SDI12I2: null,
        SDI12I3: null,
        SDI12I4: null,
        SDI12I5: null,
        SDI12I6: null,
        SDI12I7: null, //Remover
        EMR: null,
        PIR: null,
        FK_MODEL: null,
        NOTE: null,
      };
      this.modelSpecification = {
        s_modbus: [],
        p_modbus: [],
        valve: [],
        hydro: [],
        digital: [],
        sensor: [],
        onoff: [],
        pulse: [],
        i2c: [],
        sdi12: [],
      };
    },
    pickModel(model) {
      // monta a quantidade de campos
      this.pickedModel = model;
      this.makeModelSpecificationObj("s_modbus", 8, "mb");
      this.makeModelSpecificationObj("p_modbus", 8, "mb");
      this.makeModelSpecificationObj("onoff", 8, "onoff");
      this.makeModelSpecificationObj("valve", model.OUT, "out");
      this.makeModelSpecificationObj("digital", model.IN_DIGITAL, "dig");
      this.makeModelSpecificationObj("sensor", model.IN_ANALOGIC, "an");
      this.makeModelSpecificationObj("i2c", model.IN_I2C, "i2c");
      this.makeModelSpecificationObj("sdi12", model.IN_SDI12, "sdi12");
    },
    makeModelSpecificationObj(elem, len, type) {
      let list = this.modelSpecification[elem];
      let value = {};

      if (type === "sdi12") {
        let lenSDI12 = len == 1 ? 2 : len;
        for (let i = 1; i < lenSDI12; i++) {
          value = {
            EQUIPMENT: null,
            POSITION: i,
          };
          list.push(value);
          if (list.length == len) this.modelSpecification[elem] = list;
        }
        return;
      }

      for (let i = 0; i < len; i++) {
        if (type == "out") {
          if (i < 8) {
            if (i % 2 == 0)
              value = {
                EQUIPMENT: null,
                POSITION: i + 1,
                OPERATION: 1,
              };
            else
              value = {
                EQUIPMENT: null,
                POSITION: i + 1,
                OPERATION: 0,
              };
          } else
            value = {
              EQUIPMENT: null,
              POSITION: i + 1,
              OPERATION: 2,
            };
        } else
          value = {
            EQUIPMENT: null,
            POSITION: i + 1,
          };
        list.push(value);
        if (list.length == len) this.modelSpecification[elem] = list;
      }
    },
    putInputValuesInObjToSubmit(elem, name) {
      let list = this.modelSpecification[elem];
      for (let i = 0; i < list.length; i++) {
        if (name == "D" || name == "P") {
          if (name == "D") {
            //garantir que não há um sensor de pulso e um hidrômetro cadastrado na mesma entrada
            this.form[name + list[i].POSITION] = Number(
              list[i].EQUIPMENT.slice(1)
            );
            this.form["P" + list[i].POSITION] = null;
          } else {
            this.form[name + list[i].POSITION] = Number(
              list[i].EQUIPMENT.slice(1)
            );
            this.form["D" + list[i].POSITION] = null;
          }
        } else if (name == "SDI12") {
          list[i].POSITION == 1
            ? (this.form[name + "I" + list[i].POSITION] = list[i].EQUIPMENT)
            : (this.form[name + "I" + Number(list[i].POSITION)] =
                list[i].EQUIPMENT);
        } else if (name == "I2C")
          list[i].POSITION == 1
            ? (this.form[name] = list[i].EQUIPMENT)
            : (this.form[name + (Number(list[i].POSITION) - 1)] =
                list[i].EQUIPMENT);
        else {
          this.form[name + list[i].POSITION] = list[i].EQUIPMENT;
          if (name == "O")
            this.form[name + list[i].POSITION + "F"] = list[i].OPERATION;
        }
      }
    },
    joinDigitalInput() {
      let sel = this.itemToEdit;
      let len = this.itemToEdit.DIGITAL_CAPACITY;
      let digital = [];
      for (let i = 0; i < len; i++) {
        if (sel.HYDRO[i].EQUIPMENT) digital.push(sel.HYDRO[i]);
        else if (sel.PULSE[i].EQUIPMENT) digital.push(sel.PULSE[i]);
        else
          digital.push({
            EQUIPMENT: null,
            POSITION: i + 1,
          });
      }
      return digital;
    },
    separateDigitalInput() {
      this.modelSpecification.hydro = this.modelSpecification.digital.filter(
        (e) => {
          if (e.EQUIPMENT && e.EQUIPMENT[0] == "h") return e;
        }
      );
      this.modelSpecification.pulse = this.modelSpecification.digital.filter(
        (e) => {
          if (e.EQUIPMENT && e.EQUIPMENT[0] == "p") return e;
        }
      );
      this.putInputValuesInObjToSubmit("hydro", "D");
      this.putInputValuesInObjToSubmit("pulse", "P");
    },
    validateNoRepeated(obj, key) {
      let array = this.modelSpecification[key]
        .map((e) => e.EQUIPMENT)
        .filter((e) => !!e);
      if (array.length) {
        let length = array.length;
        return (
          array.filter((e, i, arr) => arr.indexOf(e) == i).length == length
        ); // todos os campos não nulos são diferentes
      } else return true; // não há cadastro nesses campos então é válido
    },
    validateNoRepeatedEquipments(modelSpecif) {
      let ok = [];
      let fail = [];
      let keys = [
        "p_modbus",
        "s_modbus",
        "sensor",
        "hydro",
        "pulse",
        "onoff",
        "i2c",
        "sdi12",
      ];
      let names = [
        "bomba modbus",
        "sensor modbus",
        "sensores analógicos",
        "hidrômetros (digital)",
        "sensores de pulso (digital)",
        "sensores on/off",
        "sensores i2c",
        "sensores sdi12",
      ];
      for (let idx in keys) {
        if (this.validateNoRepeated(modelSpecif, keys[idx]))
          ok.push(names[idx]);
        else fail.push(names[idx]);
        if (ok.length + fail.length == keys.length)
          if (fail.length) {
            alert(`Há equipamentos repetidos em ${fail}.`, "w");
            this.repetitions = fail;
            return false;
          } else return true;
      }
    },
    checkForm() {
      this.errors = [];
      let erros = [
        "A identificação do dispositivo é obrigatória. Valores permitidos: 1 a 250. Não é possível cadastrar um número já existente.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
        `Há equipamentos repetidos em ${this.repetitions}.`,
      ];
      [
        this.addrState,
        this.LATstate,
        this.LONstate,
        this.validateNoRepeatedEquipments(this.modelSpecification),
      ].map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        if (this.formType == "add") {
          this.form.FK_MODEL = this.pickedMod.ID;
          // this.form.MODEL_NAME = this.pickedMod.NAME;
        }
        this.separateDigitalInput();
        this.putInputValuesInObjToSubmit("valve", "O");
        this.putInputValuesInObjToSubmit("onoff", "L");
        this.putInputValuesInObjToSubmit("p_modbus", "M");
        this.putInputValuesInObjToSubmit("s_modbus", "SM");
        this.putInputValuesInObjToSubmit("sensor", "A");
        this.putInputValuesInObjToSubmit("i2c", "I2C");
        this.putInputValuesInObjToSubmit("sdi12", "SDI12");
        this.step = 1;
        this.form.LATITUDE = !!this.form.LATITUDE
          ? parseFloat(this.form.LATITUDE)
          : null;
        this.form.LONGITUDE = !!this.form.LONGITUDE
          ? parseFloat(this.form.LONGITUDE)
          : null;
        if (this.form.FK_MODEL) {
          return this.checkOperation(this.form).then((ret) => {
            this.resetForm();
            this.$emit("submit", ret, this.formType);
            this.$emit("close-form");
          });
        }
      }
    },
    checkOperation(form) {
      return new Promise((resolve) => {
        let arr = Array(32)
          .fill(1)
          .map((e, i) => `O${e + i}`);
        arr.map((e) => {
          if (!form[e]) form[`${e}F`] = null;
        });
        resolve(form);
      });
    },
  },
};
</script>
<style scoped>

.btn {
  margin-bottom: 5px;
}
.separator {
  margin: 0 5px;
}
@media screen and (max-width: 768px) {
  .container-details {
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    margin-right: 0;
  }
  /* padding-top: 80px; */
  /* #form,
  #details {
    padding-top: 1em;
  } */
}
</style>
